import {createReducer} from 'redux-act';
import {
  GET_LOCATION_SETTINGS_DATA,
  GET_LOCATION_SETTINGS_DATA_BY_ID,
  GET_LOCATION_SETTINGS_DATA_BY_ID_SUCCESS,
  GET_LOCATION_SETTINGS_DATA_SUCCESS,
  OPEN_CONFIRMATION_MODAL,
  OPEN_DISABLE_MODAL,
  // OPEN_LEAVE_MODAL,
  POST_LOCATION_SETTINGS_DATA,
  POST_LOCATION_SETTINGS_DATA_SUCCESS,
  UPDATE_LOCATION_SETTINGS_DATA,
  UPDATE_LOCATION_SETTINGS_DATA_SUCCESS,
  GET_CALLING_PHONE,
  GET_CALLING_PHONE_SUCCESS,
  SET_PUBLISH_BUTTON_STATE,
  PUBLISH_LOCATION_SUCCESS,
  UPDATE_LOCATION_ACCOUNT_TEMPLATE,
  OPEN_LEAVE_MESSAGE,
  OPEN_CHANGE_ADDRESS_CONFIRMATION_MODAL,
  CREATE_STORE_HOLIDAYS_REQUEST_SUCCESS,
  CREATE_STORE_HOLIDAYS_REQUEST,
  SET_STORE_HOLIDAYS,
  SET_STATUS_BUTTON,
  GET_SPECIAL_HOURS,
  GET_SPECIAL_HOURS_SUCCESS,
  CREATE_SPECIAL_HOURS_SUCCESS,
  DELETE_SPECIAL_HOURS_SUCCESS,
  SET_SPECIAL_HOURS_LOADING,
  CREATE_SPECIAL_HOURS,
  DELETE_SPECIAL_HOURS,
  SET_CREATE_SPECIAL_HOURS_LOADING,
  SET_DELETE_SPECIAL_HOURS_LOADING,
  GET_AGGREGATION_PLATFORM_SETTINGS_SUCCESS,
  SET_AGGREGATION_PLATFORM_SETTINGS_LOADING,
  GET_AGGREGATION_PLATFORM_SETTINGS,
  GET_SELF_DELIVERY_REPORT_EMAIL,
  GET_SELF_DELIVERY_REPORT_EMAIL_SUCCESS,
  SET_SELF_DELIVERY_REPORT_EMAIL_LOADING
} from './action';
import {
  PATCH_DELIVERY_OPTIONS_SUCCESS,
  TOGGLE_STORE_SUCCESS
} from '../global/globalNotifications/action';
import {PUBLISH_STATUS_DISABLE, PUBLISH_STATUS_ENABLE} from './constants';

const initialState = () => ({
  loading: true,
  dataReceived: null,
  data: {},
  callingCode: null,
  // isLeaveModalOpen: false,
  isLeaveMessageOpen: false,
  isConfirmationModalOpen: false,
  isDisableModalOpen: false,
  confirmationEntityName: '',
  confirmationProviderName: null,
  pauseAllChannels: false,
  publishStatus: PUBLISH_STATUS_ENABLE,
  isChangeAddressModalOpen: false,
  storeHolidays: {},
  disableButton: false,
  specialHours: [],
  specialHoursLoading: false,
  createSpecialHoursLoading: false,
  deleteSpecialHoursLoading: false,
  aggregationPlatformSettings: [],
  aggregationPlatformSettingsLoading: false,
  selfDeliveryReportEmail: '',
  selfDeliveryReportEmailLoading: false,
  bankAccountConnected: false,
  bankAccountLast4: null,
  bankAccountCompanyFound: false
});

const locationSettingsReducer = createReducer(
  {
    [GET_LOCATION_SETTINGS_DATA_BY_ID]: (state, payload) => ({
      ...state,
      dataReceived: null,
      loading: !payload?.noLoader
    }),
    [GET_LOCATION_SETTINGS_DATA_BY_ID_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload,
      dataReceived: true,
      loading: false
    }),
    [GET_LOCATION_SETTINGS_DATA]: (state) => ({
      ...state,
      dataReceived: null,
      loading: true
    }),
    [GET_LOCATION_SETTINGS_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload,
      dataReceived: true,
      loading: false
    }),
    [UPDATE_LOCATION_SETTINGS_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: {
        ...state.data,
        ...(payload || {})
      },
      disableButton: false
    }),
    [GET_CALLING_PHONE_SUCCESS]: (state, payload) => ({
      ...state,
      callingCode: payload.callingCode
    }),
    // [OPEN_LEAVE_MODAL]: (state, {open}) => ({
    //   ...state,
    //   isLeaveModalOpen: open
    // }),
    [OPEN_LEAVE_MESSAGE]: (state) => ({
      ...state,
      isLeaveMessageOpen: true
    }),
    [OPEN_CONFIRMATION_MODAL]: (
      state,
      {open, entityName, providerName, pauseAllChannels}
    ) => ({
      ...state,
      isConfirmationModalOpen: open,
      confirmationEntityName: entityName,
      confirmationProviderName: providerName || null,
      pauseAllChannels: !!pauseAllChannels
    }),
    [OPEN_DISABLE_MODAL]: (
      state,
      {open, entityName, providerName, pauseAllChannels}
    ) => ({
      ...state,
      isDisableModalOpen: open,
      confirmationEntityName: entityName,
      confirmationProviderName: providerName || null,
      pauseAllChannels: !!pauseAllChannels
    }),
    [PATCH_DELIVERY_OPTIONS_SUCCESS]: (state, payload) => ({
      ...state,
      data: {
        ...state.data,
        ...payload
      }
    }),
    [TOGGLE_STORE_SUCCESS]: (state, payload) => ({
      ...state,
      data: {
        ...state.data,
        ...payload
      }
    }),
    [SET_PUBLISH_BUTTON_STATE]: (store, status) => ({
      ...store,
      publishStatus: status
    }),
    [PUBLISH_LOCATION_SUCCESS]: (store, payload) => ({
      ...store,
      data: {
        ...store.data,
        updatedAt: payload?.updatedAt,
        LastBotSync: payload?.LastBotSync
      }
    }),
    [UPDATE_LOCATION_ACCOUNT_TEMPLATE]: (store) => ({
      ...store
    }),
    [OPEN_CHANGE_ADDRESS_CONFIRMATION_MODAL]: (store, {open}) => ({
      ...store,
      isChangeAddressModalOpen: open
    }),
    [CREATE_STORE_HOLIDAYS_REQUEST_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload,
      dataReceived: true,
      loading: false
    }),
    [SET_STORE_HOLIDAYS]: (state, payload) => ({
      ...state,
      storeHolidays: payload
    }),
    [SET_STATUS_BUTTON]: (state, payload) => ({
      ...state,
      disableButton: payload
    }),
    [GET_SPECIAL_HOURS]: (state) => ({
      ...state,
      specialHoursLoading: true
    }),
    [GET_SPECIAL_HOURS_SUCCESS]: (state, payload) => ({
      ...state,
      specialHours: payload,
      specialHoursLoading: false
    }),
    [CREATE_SPECIAL_HOURS]: (state) => ({
      ...state,
      createSpecialHoursLoading: true
    }),
    [CREATE_SPECIAL_HOURS_SUCCESS]: (state, payload) => {
      const result = [...state.specialHours, payload];
      return {
        ...state,
        specialHours: result,
        createSpecialHoursLoading: false
      };
    },
    [DELETE_SPECIAL_HOURS]: (state) => ({
      ...state,
      deleteSpecialHoursLoading: true
    }),
    [DELETE_SPECIAL_HOURS_SUCCESS]: (state, payload) => {
      const result = state.specialHours.filter((hour) => hour.id !== payload);
      return {
        ...state,
        specialHours: result,
        deleteSpecialHoursLoading: false
      };
    },
    [SET_SPECIAL_HOURS_LOADING]: (state, payload) => ({
      ...state,
      specialHoursLoading: payload
    }),
    [SET_CREATE_SPECIAL_HOURS_LOADING]: (state, payload) => ({
      ...state,
      createSpecialHoursLoading: payload
    }),
    [SET_DELETE_SPECIAL_HOURS_LOADING]: (state, payload) => ({
      ...state,
      deleteSpecialHoursLoading: payload
    }),
    [GET_AGGREGATION_PLATFORM_SETTINGS]: (state) => ({
      ...state,
      aggregationPlatformSettingsLoading: true
    }),
    [GET_AGGREGATION_PLATFORM_SETTINGS_SUCCESS]: (state, payload) => ({
      ...state,
      aggregationPlatformSettings: payload,
      aggregationPlatformSettingsLoading: false
    }),
    [SET_AGGREGATION_PLATFORM_SETTINGS_LOADING]: (state, payload) => ({
      ...state,
      aggregationPlatformSettingsLoading: payload
    }),
    [GET_SELF_DELIVERY_REPORT_EMAIL]: (state) => ({
      ...state,
      selfDeliveryReportEmailLoading: true
    }),
    [GET_SELF_DELIVERY_REPORT_EMAIL_SUCCESS]: (state, payload) => ({
      ...state,
      selfDeliveryReportEmail: payload?.email || '',
      bankAccountConnected: Boolean(payload?.bankAccountConnected),
      bankAccountLast4: payload?.bankAccountLast4 || null,
      bankAccountCompanyFound: Boolean(payload?.companyFound),
      selfDeliveryReportEmailLoading: false
    }),
    [SET_SELF_DELIVERY_REPORT_EMAIL_LOADING]: (state, payload) => ({
      ...state,
      selfDeliveryReportEmailLoading: payload
    })
  },
  initialState()
);

export default locationSettingsReducer;
